import { useState, useEffect } from "react";
import { unauthenticatedApi, coverageApi } from "../Api";
import useStateMachineWrapper from "../helpers/useStateMachineWrapper";
import { setCookie } from "../helpers/cookies";
import { dataLayerPush } from "../helpers/analytics";
import { BeatLoader } from "react-spinners";

const AddressSearch = (props) => {
    const {actions, state} = useStateMachineWrapper();

    const [searchOptions, setSearchOptions] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [hasSearched, setHasSearched] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);

    useEffect(() => {
        const getData = setTimeout(() => {
            coverageApi.get(`address/${searchValue}`)
            //unauthenticatedApi.get(`?endpoint=address-lookup&search=${searchValue}`)
            .then(response => {
                setSearchOptions(response.data.Response.results.slice(0, 20));
                setHasSearched(true);
            });
            /*coverageApi.interceptors.request.use(request => {
                console.log('Starting Request', request);
                console.log('Request Headers:', request.headers);
                return request;
            });*/
        }, 500);

        return () => clearTimeout(getData);
    }, [searchValue]);

    const chooseAddress = (address) => {
        if(!address) {
            return;
        }
        setIsProcessing(true);
        console.log('add',state.session.currentAddress);
        console.log('new add',address);
        actions.update({
            currentAddress: address,
            addressStatus: address.fiber_status,
            mainLine: address.main_line,

            fullAddress: address.full_address,
            // addressResult: addRes, // WHAT IS THIS
            addressZip: address.fill_zip,
            address: address.fill_address,
            addressID: address.id,
            city: address.city,
            cityID: address.city_id,
            apt: address.fill_apt,
            state: address.state,
            zip: address.fill_zip,
            ip: typeof _I3_USER_IP !== 'undefined' ? _I3_USER_IP : '', // eslint-disable-line
            // browser: browser,
            marketID: address.market_id,
            sector: address.sector,
            //mainline: step, // TODO - FIGURE THIS OUT
            speed: '',
            promoGroupID: 0,
            // reset promos
            promoID: '',
            promoName: '',
        });// session.setCurrentAddress(address);

        if(address.fill_zip) {
            setCookie('zip', address.fill_zip, 30);
        }

        if(address.redirect_signup !== false) {
            setSearchValue(''); // use to stop unsaved form data
            actions.setPage('intro'); // always reset to intro page
            //window.location.assign(address.redirect_signup);
            const data = {
                MarketID: '28',
                LegacyRIBuyflow: 'Y'
            };
            const form = document.createElement('form');
            form.method = 'POST';
            form.action = address.redirect_signup;

            for (const key in data) {
                if (data.hasOwnProperty(key)) {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = data[key];
                form.appendChild(input);
                }
            }

            document.body.appendChild(form);
            form.submit();

            /*
            useEffect(() => {
                // console.log('CURRENT ADDRESS WAS UPDATED');
                if(currentAddress.fill_zip) {
                    setCookie('zip', currentAddress.fill_zip, 30);
                }
                // go to appropriate page based on whether the current address is in network or not
                // TODO: go to RI-specific signup if in RI
            }, [currentAddress]);
            */

            return;
        }

        if(address.can_preorder) {
            dataLayerPush({
                'event' : 'pre-sale'
            });
            // actions.setPage('presale');
            actions.update({isPreorder: true, page: 'presale'});

            return;
        }

        if(!address.signup_available) {
            actions.setPage('address-unavailable');
            return;
        }

        dataLayerPush({
            'event' : 'active-sale'
        });

        // TODO: add a "great! it's available screen"
        actions.update({isPreorder: false, page: 'address-available'});
    }

    return (
        <div className="w-full max-w-xl mx-auto mt-2">
            <div className="address-search-container">
                <input
                    id='searchbox'
                    type="text"
                    placeholder="Street address, City, State, Zipcode"
                    onChange={(e) => {
                        setSearchValue(e.target.value);
                        setHasSearched(false);
                    }}
                    value={searchValue}
                    className="w-full"
                />
            </div>
            {(searchValue.length > 5) && (
                <div className="relative text-left mt-2">
                    {searchOptions.length > 0 ? (
                        <ul className="address-results">
                            {searchOptions.map(option => (
                                <li 
                                    key={option.id} 
                                    className="rounded-lg shadow p-4 mb-1 hover:bg-purple hover:text-white cursor-pointer transition flex justify-between" 
                                    onClick={() => chooseAddress(option)}
                                >
                                    {option.full_address}
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                                    </svg>
                                </li>
                            ))}
                        </ul>
                    ) : (
                        hasSearched && (
                            <ul className="address-results">
                                <li className="rounded-lg shadow p-4 mb-1 hover:bg-purple hover:text-white cursor-pointer transition flex justify-between">
                                    Currently service unavailable at this address
                                </li>
                            </ul>
                        )
                    )}
                    {isProcessing && (
                        <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center">
                            <BeatLoader color="#ffc72d" loading={isProcessing}/>
                        </div>
                    )}
                </div>
            )}
        </div>
    )
};

export default AddressSearch;